import axios from '../api'

const queryUserInfo = () => axios({ url: `eos/coupon/login/getAuthSession` })
const createGroup = () => axios({ url: `eos/coupon/group/systemCreateGroup` })
// const signOff = params => {
//   return axios({
//     url: `https://epassport.diditaxi.com.cn/passport/login/v5/signOff`,
//     method: 'post',
//     data: params
//   })
// }
const signOff = params => {
  let body = `q=${params['q']}`
  let header = new Headers()
  header.append('Content-Type', 'application/x-www-form-urlencoded')
  return fetch('https://epassport.diditaxi.com.cn/passport/login/v5/signOff', {
    body: body,
    mode: 'cors',
    method: 'POST',
    headers: header
  })
}
const queryTaskList = params => axios({ url: `/eos/coupon/task/queryTaskList`, params })
const cancelTask = params => axios({ url: `/eos/coupon/task/cancelTask`, params })
const getDiscount = params => axios({ url: `/eos/coupon/orderManager/getDiscount`, params })
const getAgreement = params=> fetch('https://api.udache.com/gulfstream/confucius/api/privacy/app/popList?appid=50025&scene_str=chuxingquan&caller=chuxingquan')
export default {
  queryUserInfo,
  createGroup,
  signOff,
  queryTaskList,
  cancelTask,
  getDiscount,
  getAgreement
}

// let header = new Headers()
//   header.append("Content-Type", "application/x-www-form-urlencoded")
//   fetch('https://epassport.diditaxi.com.cn/passport/login/v5/signOff', {
//     body:`q=${JSON.stringify(Object.assign({
//       "appid":90000,
//       "api_version":'1.0.0'
//     }, {
//       ticket:'wAMLsdl5mGsvnp4lrq8J8GzUU34mgtng6Aa7wAePFk8kzE2KwzAQROG7vHVjqmVJlvo28-OZZKNAQlbGdw_CtXlQi-9giGBdtAhjOOHGSESRkoyxEjOZ8JLVNnlPxigEGF9XvomWe065V5eql2z8Eq0ZO3HweryfPzuxSfLT-Lu0VMs6tX8Cd82l3ivGbT4Yd0LnJwAA__8%3D'
//     }))}`,
//     mode: 'cors',
//     method: 'POST',
//     headers: header
//   })
